import { useState } from 'react'
import ProfileCard from 'Components/profilePage/ProfileCard'
import { connect } from "react-redux";
import NotLoggedIn from "Components/notLoggedIn";
import { withRouter } from 'react-router-dom'
import CustomModal from "Utills/Model/CustomModel";
import SiginInPopup from "Components/Popup/SiginInPopup/SiginInPopup";
import defaultCardImg from "assets/Images/icons/defaultCardImg.png"
import SliderCard from "Components/sliderCard/SliderCard"
import nextIcon from "assets/Images/icons/next.png";

//============================= THIS IS A Favorites YACHTS PAGE =========================
const Favorites = (props) => {
    let user = props.current_user;
    const [activeTab, setActiveTab] = useState(0);
    const [loginOpen, setLogin] = useState(false);

    // CHECK user is logged in or not
    if (user && user?.isAuth) {
        return (
            <div className="favorites-page">
                <div className="cs_container header-spacer">
                    <div className="row">
                        <div className="col-12 mx-auto">
                            <div className="row">
                                <div className="col-md-3">
                                    {user.is_captain ?
                                        <ProfileCard
                                            data={{
                                                profileImg: user?.profileImg || '.',
                                                userName: user.name + ' ' + user.surname + " ",
                                                subInfo: '38, Greece',
                                                mode: user?.is_captain,
                                                heading2: "All booking history",
                                                heading3: "Favorite List",
                                                heading4: "Messaging",
                                            }} />
                                        :
                                        <ProfileCard
                                            data={{
                                                profileImg: user?.profileImg || '.',
                                                userName: user.name + ' ' + user.surname + " ",
                                                subInfo: '38, Greece',
                                                mode: user?.is_captain,
                                                heading2: "All booking history",
                                                heading3: "Favorite List",
                                                heading4: "Messaging",
                                            }} />
                                    }
                                </div>
                                <div className="col-md-9 col-12 ">
                                    <h4 className="text-gr mb-md-4 mt-md-0 mt-3 p-md-0 p-2">Favorite List  ( <span className="text-sec">8</span> )</h4>
                                    <div className="row mt-2">
                                        {[0, 1, 2, 3, 4, 5, 6, 7].map((v, i) => (
                                            <div className="col-sm-4 col-12">
                                                <SliderCard
                                                    type="favItem"
                                                    user={user}
                                                    openLoginModel={setLogin}
                                                    linkEnabled={true}
                                                    link={'/yachtDetail/' + i}
                                                    data={{
                                                        id: i,
                                                        img: defaultCardImg,
                                                        title: "Motorboat Azimut 62",
                                                        location: "Crete.Greece",
                                                        price: "1260"
                                                    }}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                    <div className="d-flex justify-content-md-end justify-content-center  align-items-center py-4 mb-3">
                                        <div className="cs-pagination-wrapper m-0">
                                            <div onClick={() => setActiveTab(0)} tabIndex="0" className={`cs-pagination-item ${activeTab === 0 ? "active-paging" : ""}`}>
                                                <span>1</span>
                                            </div>
                                            <div onClick={() => setActiveTab(1)} tabIndex="0" className={`cs-pagination-item ${activeTab === 1 ? "active-paging" : ""}`}>
                                                <span>2</span>
                                            </div>
                                            <div onClick={() => setActiveTab(2)} tabIndex="0" className={`cs-pagination-item ${activeTab === 2 ? "active-paging" : ""}`}>
                                                <span>3</span>
                                            </div>
                                            <div onClick={() => setActiveTab(3)} tabIndex="0" className={`cs-pagination-item ${activeTab === 3 ? "active-paging" : ""}`}>
                                                <span>4</span>
                                            </div>
                                            <div onClick={() => setActiveTab(4)} tabIndex="0" className={`cs-pagination-item ${activeTab === 4 ? "active-paging" : ""}`}>
                                                <span>5</span>
                                            </div>
                                            <div onClick={() => setActiveTab("next")} tabIndex="0" className={`cs-pagination-item active-paging`}>
                                                <img src={nextIcon} alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* login model popUP */}
                <CustomModal openPopup={loginOpen} setOpenPopup={setLogin} >
                    <SiginInPopup
                        closeModel={setLogin}
                    />
                </CustomModal>
            </div>
        )

    } else {
        //==================== not logged in ==================
        return (
            <NotLoggedIn />
        )
    }
};

// REDUX CONFIGS
const mapStateToProps = (store) => ({
    current_user: store.current_user,
});

export default connect(mapStateToProps, null)(withRouter(Favorites));
